import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethod } from '../../model/payment-method';

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {

  transform(paymentMethod: PaymentMethod): string {
    if (paymentMethod?.paymentMethodType === 'CREDIT_CARD' && paymentMethod?.cardBrand === 'PCARD') {
      return "Paycell Kartım";
    } else if (paymentMethod?.paymentMethodType === 'CREDIT_CARD') {
      return "Kredi Kartım"
    } else if (paymentMethod?.paymentMethodType === 'DCB') {
      return "Faturana Yansıt Limitim"
    } else if (paymentMethod?.paymentMethodType === 'PAYE_CARD') {
      return "Paye Kartım"
    }
    return paymentMethod?.paymentMethodType;
  }

}
